import config from '../../config';
import { createComponentStore } from '../../utils/createComponentStore';

const defaultWebhookData = () => ({
  endpoint: '',
  json: '',
  type: 'open_endpoint',
  samplePlaceholders: [{
    key: 'wbhk' + (Math.floor(Math.random() * 90000000) + 10000).toString(),
    sampleKey: '',
    sampleData: '',
    checked: true,
  }],
  placeholders: [],
});

const { getStore, defaultStore } = createComponentStore({
  type: 'wbhk',
  endpoint: 'webhook',
  registryKey: 'webhook',
  initData: defaultWebhookData,

  extraState: () => ({
    position: null,
    json: undefined,
    error: false,
    errorJsonMessage: '',
    placeholderError: [],
  }),

  extraActions: (set, get) => ({
    keyAuto: () => 'wbhk' + (Math.floor(Math.random() * 90000000) + 10000).toString(),

    componentData: () => {
      const s = get();
      const obj = s.dataField();
      return {
        endpoint: `${config.WEBHOOK_ENDPOINT.PRODUCTION}/${s.componentId}`,
        json: '',
        type: 'open_endpoint',
        samplePlaceholders: [obj],
        placeholders: [],
      };
    },

    dataField: () => ({
      key: get().keyAuto(),
      sampleKey: '',
      sampleData: '',
      checked: true,
    }),

    setWebhookImportBody: (Body) => set({ json: Body }),

    setField: (value, index, type) => {
      set((s) => {
        const data = { ...s.data };
        switch (type) {
          case 'sample':
            data.json = value;
            break;
          case 'key':
            data[index] = { ...data[index], key: value };
            break;
          case 'type':
            data.type = value;
            data.placeholders = [];
            break;
          case 'content':
            data[index] = { ...data[index], content: value };
            break;
        }
        return { data };
      });
    },

    setErrorMessage: (error) => set({ errorJsonMessage: error }),

    setRawResponsePH: (value) => {
      set((s) => ({
        data: {
          ...s.data,
          samplePlaceholders: [
            { key: value, sampleKey: value, sampleData: '', checked: true },
          ],
        },
      }));
    },

    addRow: () => {
      const obj = get().dataField();
      set((s) => ({
        data: {
          ...s.data,
          samplePlaceholders: [...s.data.samplePlaceholders, obj],
        },
      }));
    },

    jsonData: (key, value) => ({
      key,
      sampleKey: key,
      sampleData: value,
      checked: true,
    }),

    addJsonData: (obj) => {
      set((s) => ({
        data: {
          ...s.data,
          samplePlaceholders: [...s.data.samplePlaceholders, obj],
        },
      }));
    },

    clearField: () => {
      set((s) => ({ data: { ...s.data, samplePlaceholders: [] } }));
    },

    deleteRow: (placeholder) => {
      set((s) => {
        const placeholders = [...s.data.samplePlaceholders];
        const index = placeholders.findIndex((x) => x.key === placeholder.key);
        if (index >= 0) placeholders.splice(index, 1);
        return { data: { ...s.data, samplePlaceholders: placeholders } };
      });
    },

    onChangeField: (value, placeholder, type) => {
      if (type === 'json') {
        set((s) => ({ data: { ...s.data, json: value } }));
        return;
      }
      set((s) => {
        const placeholders = [...(s.data?.samplePlaceholders || [])];
        const index = placeholders.findIndex((x) => x.key === placeholder?.key);
        if (index < 0) return {};
        placeholders[index] = { ...placeholders[index] };
        switch (type) {
          case 'content':
            placeholders[index].sampleKey = value;
            placeholders[index].sampleData = '';
            break;
          case 'key':
            placeholders[index].key = value;
            break;
        }
        return { data: { ...s.data, samplePlaceholders: placeholders } };
      });
    },

    addComponentData: () => {
      const obj = get().componentData();
      set((s) => {
        const data = Array.isArray(s.data) ? [...s.data, obj] : [s.data, obj];
        return { data };
      });
    },

    deleteComponent: (index) => {
      set((s) => {
        const data = Array.isArray(s.data) ? [...s.data] : [s.data];
        data.splice(index, 1);
        return { data };
      });
    },

    storeError: (obj) => set({ placeholderError: obj }),

    setWebhookName: (name) => set({ name }),

    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        position: s.position,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
      };
    },
  }),
});

export const getWebhookImportStore = getStore;
export default defaultStore;
